/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { css } from 'styled-components';
import { borderRadius } from './border';
import { colors } from './colors';
import gridUtils from './grid';

const { breakpoints } = gridUtils;
const layers = {
  base: css`
    background-color: ${colors.grey05};
    border: none;
    border-radius: ${borderRadius};
  `,
  flat: css`
    background-color: ${colors.white};
    border: 1px solid ${colors.grey20};
    border-radius: ${borderRadius};
  `,
  raised: css`
    background-color: ${colors.white};
    border: none;
    border-radius: ${borderRadius};
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  `,
  overlay: css`
    background-color: ${colors.white};
    border: none;
    border-radius: ${borderRadius};
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
  `,
  navigation: css`
    background-color: ${colors.white};
    border: none;
    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.1);
  `,
  modal: css`
    background-color: ${colors.white};
    border: none;
    border-radius: ${borderRadius};
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);
    @media (max-width: ${breakpoints.sm}) {
      box-shadow: none;
    }
  `
};

export default layers;
